import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

// Mirrors the prod/dev split used for OIDC config in App.tsx — the same build can be
// served from either domain, so the connection string is picked at runtime by origin.
const isProd = window.location.origin.includes('elvisconnect.eurofinsanz.com');
const connectionString = isProd
    ? process.env.REACT_APP_APPINSIGHTS_PROD
    : process.env.REACT_APP_APPINSIGHTS_DEV;

export const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
    config: {
        connectionString,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableUnhandledPromiseRejectionTracking: true,
        enableAjaxErrorStatusText: true,
        disableAjaxTracking: false,
    }
});

// Telemetry is optional: without a connection string the SDK stays disabled.
if (connectionString) {
    appInsights.loadAppInsights();
}

export const trackException = (error: any, properties?: Record<string, any>) => {
    if (!connectionString || !error) return;
    const exception = error instanceof Error ? error : new Error(String(error?.message ?? error));
    appInsights.trackException({ exception, severityLevel: SeverityLevel.Error }, properties);
};

// One-off startup probe: a fetch that throws here (before any request even reaches
// the server) means a corporate firewall/proxy/DNS is blocking the API outright,
// which is distinct from an HTTP error response handled by the axios interceptor.
export const checkNetworkConnectivity = async (url: string = process.env.REACT_APP_BASE_URL) => {
    if (!connectionString || !url) return;
    try {
        await fetch(url, { method: 'HEAD', mode: 'no-cors' });
    } catch (ex: any) {
        appInsights.trackEvent({
            name: 'NetworkBlocked',
            properties: { error: ex?.message, url }
        });
    }
};

export default appInsights;
